import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})

export class AccountService {

  constructor(
    private http: HttpClient
  ) { }

  checkMobile(model) {
    return this.http.post(environment.baseUrl + `Preregistration_CheckMobile`, model);
  }

  loginByDolateMan(model) {
    return this.http.post(environment.baseUrl + `Preregistration_InfoBaseShilatMan`, model);
  }

  otpCheck(model) {
    return this.http.post(environment.baseUrl + `Preregistration_CheckOTP`, model);
  }

  otpAgain(model) {
    return this.http.post(environment.baseUrl + `Preregistration_ReSendOTP`, model);
  }

  register(model) {
    return this.http.post(environment.baseUrl + `Shapad_Preregistration_Save`, model);
  }

  update_UserInfo(model) {
    return this.http.post(environment.baseUrl + `Shapad_Preregistration_Update`, model);
  }

  appAbility() {
    return this.http.post(environment.baseUrl + `Dyar_GetAppAbility`, {});
  }

  GetState() {
    return this.http.post(environment.baseUrl + `Shapad_State_List`, {});
  }

  floatingType() {
    return this.http.post(environment.baseUrl + `FloatingType_List`, {});
  }

  GetCity(code) {
    return this.http.post(environment.baseUrl + `Shapad_City_List4State?strState=${code}`, {});
  }

  GetCityNew(code) {
    return this.http.post(environment.baseUrl + `GetCity2?strSate=${code}`, {});
  }

  checkOtp(hpnumber, otp) {
    return this.http.post(environment.baseUrl + 'App_CheckRegisterOTP', {
      strMobile: hpnumber,
      strActivateCode: otp,
    });
  }

  ReverseGeocoding(fLon, fLat) {
    var model = {
      fLon: fLon,
      fLat: fLat,
    };
    return this.http.post(environment.baseUrl + `ReverseGeocoding`, model);
  }

  GetUserAbility(model) {
    return this.http.post(environment.baseUrl + `GetUserAbility`, model);
  }

  payInvoice(model) {
    return this.http.post(environment.baseUrl + `Shapad_PayInvoice`, model);
  }

  checkout_payment(model) {
    return this.http.post(environment.baseUrl + `Shapad_CheckPayment`, model);
  }

  userInfo(model) {
    return this.http.post(environment.baseUrl + `Preregistration_Info`, model);
  }

  specialistLogin(model) {
    return this.http.post(environment.baseUrl + `Preregistration_Login4Admin`, model);
  }

  specialistRegistration(model) {
    return this.http.post(environment.baseUrl + `Shapad_Preregistration_Save4Admin`, model);
  }

  preregistration_SetCode(model) {
    return this.http.post(environment.baseUrl + `Preregistration_SetTrackingCode`, model);
  }

  preregistrationSetCode2(model) {
    return this.http.post(environment.baseUrl + `Preregistration_SetTrackingCode2`, model);
  }

  specialistChangePassword(model) {
    return this.http.post(environment.baseUrl + `Preregistration_ChangePassword4Admin`, model);
  }

  specialistForgetPassword(model) {
    return this.http.post(environment.baseUrl + `Preregistration_ForgetPassword`, model);
  }

  specialistCheckMobile(model) {
    return this.http.post(environment.baseUrl + `Preregistration_CheckMobile4Admin`, model);
  }

  myRegistrations(model) {
    return this.http.post(environment.baseUrl + `Preregistration_MySelf`, model);
  }

  shilatInvoice(model) {
    return this.http.post(environment.baseUrl + `Shapad_Invoice`, model);
  }

  preInvoiceDetail(model) {
    return this.http.post(environment.baseUrl + `Shapad_PreInvoiceDetail`, model);
  }

  toastSwal(type, title) {
    Swal.fire({
      position: 'bottom-end',
      icon: type,
      toast: true,
      background: type == 'success' ? '#008631' : type == 'error' ? '#DF1C24' : type == 'warning' ? '#54c3e6' : '#3fc3ee',
      color: '#fff',
      timerProgressBar: true,
      title,
      customClass: {
        title: 'toaster-lineSpacing',
      },
      showConfirmButton: false,
      timer: 3000
    });
  }
}
